import { useSelector } from 'react-redux';
import { useState } from 'react';
import ChemComposition from '../ChemComposition/ChemComposition';
import MineralComposition from '../MineralComposition/MineralComposition';

const Composition = () => {
    const selectedPoint = useSelector(state => state.points.selectedPoint);
    const [compositionType, setCompositionType] = useState("chemical");

    if(!selectedPoint){
        return (<div>
            <ChemComposition />
            <div style={{'height': '20px'}}></div>
            <MineralComposition />
        </div>)
    } else {
        if (compositionType === "chemical") {
            return <ChemComposition setCompositionType={setCompositionType}/>;
        } else {
            return <MineralComposition setCompositionType={setCompositionType}/>
        }
    }
};

export default Composition;